"use strict";
// const body = document.querySelector('body');
var thisIs = document.createElement("div");
thisIs.className = "message";
thisIs.innerText = "Promise was resolved!";
var promise1 = new Promise(function(resolve, reject) {
    document.querySelector(".logo").addEventListener("click", function() {
        resolve();
    });
});
function isReject() {
    var thisIsBad = document.createElement("div");
    thisIsBad.className = "message error-message";
    thisIsBad.innerText = "Promise was rejected!";
    document.querySelector("body").append(thisIsBad);
}
promise1.then(function() {
    var div = document.createElement("div");
    div.className = "message";
    div.textContent = "Promise was resolved!";
    document.body.appendChild(div);
}).catch(function() {
// ерорщина
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise2.then(function() {}).catch(isReject);

//# sourceMappingURL=index.4a3d1d0b.js.map
